import { ICellRendererParams } from 'ag-grid-community';
import React from 'react';
import styled from 'styled-components';
import { ReactComponent as StarRating } from 'assets/svgs/rating-star.svg';
import { EmptyCell } from 'components/atoms/empty-cell';
import { ProductiveHeading07 } from 'components/styles';

const Value = styled.span`
  ${ProductiveHeading07};
`;

export const RatingRenderer = ({ value }: ICellRendererParams): JSX.Element => {
  return value?.value ? (
    <div>
      <StarRating /> <Value>{value.value}</Value> / {value.scale}{' '}
    </div>
  ) : (
    <EmptyCell />
  );
};
